import { render } from "./NewSvgContainer.vue?vue&type=template&id=c25c6e60&scoped=true"
import script from "./NewSvgContainer.vue?vue&type=script&lang=js"
export * from "./NewSvgContainer.vue?vue&type=script&lang=js"

import "./NewSvgContainer.vue?vue&type=style&index=0&id=c25c6e60&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c25c6e60"]])

export default __exports__